export const SCREEN_SM = 640
export const SCREEN_MD = 768
export const SCREEN_LG = 1024
export const SCREEN_XL = 1280
export const SCREEN_2XL = 1536

export const TOP_BAR_HEIGHT = 52
export const SHOP_TOP_BAR_HEIGHT = 52

export const SLIDER_SWIPE_THRESHOLD = 50

export const PROTOCOL_DOMAIN = '.protocol.store'
export const PROTOCOL_SUPPORT_EMAIL = 'support@protocol.store'

export const EMAIL_TEMPLATE_PROTOCOL_LOGO = 'https://i.imgur.com/80KqNco.png'
export const EMAIL_TEMPLATE_PROTOCOL_TEXT_LOGO =
  'https://i.imgur.com/9WWienT.png'
export const EMAIL_TEMPLATE_PROTOCOL_TEXT_LOGO_DARK =
  'https://i.imgur.com/jdN4RBN.png'
export const EMAIL_TEMPLATE_PROTOCOL_THUMBNAIL =
  'https://i.imgur.com/K3o8r9G.png'
export const EMAIL_TEMPLATE_ORDER_IMAGE_FALLBACK =
  'https://i.ibb.co/7xtVVdZF/no-image-found.png'
export const EMAIL_TEMPLATE_ORDER_PANEL_BACKGROUND =
  'https://i.ibb.co/39Y1n1tj/email-gradient-noise.png'

export const SEO_IMAGE_OPTIONS = {
  width: 800,
  height: 420,
  resizeMode: 'scale' as const,
}

// File Upload Constants
export const MAX_FILE_UPLOAD = 5
export const MAX_IMAGE_FILE_SIZE = 5 * 1024 * 1024 // 5MB
export const MAX_VIDEO_FILE_SIZE = 20 * 1024 * 1024 // 20MB

export const DETAILS_PANEL_WIDTH = 465
